// extracted by mini-css-extract-plugin
module.exports = {"input":"Individuals_input__1T8Ax","input__noAddButton":"Individuals_input__noAddButton__2ndFC"};